
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

define('component!ValidatedInputComponent',['require','react','create-react-class','classnames'],function (require) {
  'use strict';

  var React = require('react');
  var ReactCreateClass = require('create-react-class');
  var cx = require('classnames');

  var ValidatedInput = ReactCreateClass({
    displayName: 'ValidatedInputComponent',

    hasErrors: function hasErrors() {
      return this.props.errors.length > 0;
    },

    onValueChange: function onValueChange(e) {
      this.props.valueHook.requestChange(e.target.value);
    },

    render: function render() {
      var classes = cx({
        'validated-input-component': true,
        'is-invalid': this.hasErrors(),
        'tooltip': this.hasErrors()
      });

      var _props = this.props;
      var errors = _props.errors;

      var other = _objectWithoutProperties(_props, ['errors']);

      // Support for the ... syntax requires the harmony flag to be enabled for the JSX transformer
      delete other.valueHook;
      return React.createElement('input', _extends({}, other, {
        className: classes,
        title: errors,
        value: this.props.valueHook.value,
        onChange: this.onValueChange
      }));
    }
  });

  return ValidatedInput;
});
